import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
// import Loader from '../../components/Loader';
import Grid from '@material-ui/core/Grid';
// import FormGroup from '@material-ui/core/FormGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import autoBind from 'react-autobind';
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

function getModalStyle() {
  const top = '50%';
  const left = '50%';

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const styles = theme => ({
  paper: {
    position: 'absolute',
    top: '30%',
    left: '35%',
  },
  main: {
    padding: '10px',
    backgroundColor: '#ebebeb',
    borderBottom: '1px Solid',
  },
  right: {
    textAlign: 'right',
  },
  left: {
    textAlign: 'left',
  },
  title: {
    textAlign: 'left',
    marginBottom: '10px',
  },
  bookmarkBtn: {
    backgroundColor: '#757171',
    color: 'white',
  },
  bookmarkBody: {
    backgroundColor: '#f9f9f9',
    maxHeight: '300px',
    overflow: 'scroll',
  },
  checkLink: {
    textAlign: 'left',
    padding: '20px',
  },
  container: {
    textAlign: 'left',
    paddingLeft: '20px',
  },
  next: {
    marginBottom: '15px',
  },
  nextBtn: {
    backgroundColor: '#757171',
    color: 'white',
  },
  boardName: {
    marginLeft: '10px',
    marginTop: '10px',
  },
  addBoard: {
    marginTop: '10px',
    marginLeft: '10px',
    marginBottom: '10px',
  },
  bottom: {
    marginBottom: '15px',
  },
  saveBtn: {
    backgroundColor: '#757171',
    color: 'white',
  },
});

const dummyData = [
  { id: '1', type: 'listicle', name: 'Darjeeling Hot Momos' },
  { id: '2', type: 'listicle', name: 'Kumbakoram Degree Coffee' },
  { id: '3', type: 'listicle', name: 'Santosh Bread Omelet' },
  { id: '4', type: 'listicle', name: 'Pani Puri-JNC' },
];
const dummyBoardData = [
  { id: '1', type: 'board', name: 'Visit someday' },
  { id: '2', type: 'board', name: 'Bangalore' },
  { id: '3', type: 'board', name: 'Kormangala' },
  { id: '4', type: 'board', name: 'I want to go' },
];

class SimpleModal extends React.Component {
  openPopup;

  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentDidMount() {

  }
  state = {
    open: true,
    bookmarks: dummyData,
    bookmarkTab: true,
    bookmarked: [],
  };

  handleClose = () => {
    this.setState({ open: false });

    // this.setState({ bookmark: false });
  };

  handleNext = data => {
    //API HIT WITH DATA
    let json = {
      "boardName": "string",
      "bookmark": [
        {
          "createdAt": "2019-03-15T07:04:58.106Z",
          "id": data.id,
          "resourceId": data.id,
          "resourceType": data.resourceType,
          "updatedAt": "2019-03-15T07:04:58.106Z"
        }
      ]
    }
    this.setState({ open: false });
    this.props.dispatch(actions.addBookmark(json));


    // this.props.call(data);
    // console.log(a);
  };
  onCheck = (e, path) => {
    if (e.target.checked) {
      let addBookmark = this.state.bookmarked.concat(path);
      this.setState({ bookmarked: addBookmark });
    } else {
      let deleteBookmark = this.state.bookmarked;
      for (var i = 0; i < deleteBookmark.length; i++) {
        if (deleteBookmark[i] === path) {
          deleteBookmark.splice(i, 1);
        }
      }
      this.setState({ bookmarked: deleteBookmark });
    }
  };

  render() {
    const { classes } = this.props; // name
    // let bookData = dummyData;
    let boardData = dummyBoardData;
    if (this.props.open) {
      this.openPopup = true;
    }
    // this.openPopup = this.props.open;

    // console.log(this.openPopup)

    let title = this.props.name;
    // if (this.props.data1) {
    //   bookData = this.props.data1.tags;
    // }

    // const bookmarkTab = this.state.bookmarkTab;

    return (
      <div>
        {this.openPopup === true ? (
          <div>
            <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              open={this.state.open}
              onClose={this.handleClose}
            >
              <div style={getModalStyle()} className={classes.paper}>
                <div>
                  <div className={classes.main}>
                    <Grid container>
                      <Grid item xs={12} className={classes.right}>
                        <IconButton onClick={this.handleClose}>
                          <Close />
                        </IconButton>
                      </Grid>
                      <Grid item xs={12} className={classes.title}>
                        <span>Add eateries from "{title}"</span>
                      </Grid>
                    </Grid>
                  </div>
                  {/* {bookmarkTab === true && (
          <div className={classes.bookmarkBody}>
            <Grid container>
              <Grid item xs={12} className={classes.checkLink}>
                <span>Select All | Deselect All</span>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} className={classes.container}>
                <FormGroup row>
                  {bookData.map((book, i) => (
                    <Grid item xs={12} key={book.id.toString()}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={book.name}
                            onChange={e => this.onCheck(e, book.name)}
                          />
                        }
                        label={book.name}
                      />
                    </Grid>
                  ))}
                </FormGroup>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={1} />
              <Grid item xs={10} className={classes.next}>
                <Button
                  variant="contained"
                  component="span"
                  fullWidth={true}
                  onClick={this.handleNext}
                  className={classes.nextBtn}
                >
                  NEXT
                </Button>
              </Grid>
            </Grid>
          </div>
        )} */}
                  {/* {bookmarkTab === false && ( */}
                  <div className={classes.bookmarkBody}>
                    <Grid container>
                      <Grid item xs={12} className={classes.checkLink}>
                        <span>Add to a BOARD</span>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} className={classes.left}>
                        {boardData.map((board, i) => (
                          <Button
                            variant="contained"
                            component="span"
                            key={board.id}
                            className={classes.boardName}
                          >
                            {board.name}
                          </Button>
                        ))}
                        <Grid item xs={12}>
                          <Button
                            variant="contained"
                            component="span"
                            className={classes.addBoard}
                          >
                            Add a new
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={1} />
                      <Grid item xs={10} className={classes.bottom}>
                        <Button
                          variant="contained"
                          component="span"
                          fullWidth={true}
                          onClick={e => this.handleNext(this.props.data)}
                          className={classes.saveBtn}
                        >
                          SAVE
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                  {/* )} */}
                </div>
              </div>
            </Modal>
          </div>
        ) : (
            ''
          )}
      </div>
    );
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};


function mapStateToProps(state) {
  return selectors.getAllValues(state);
}
// We need an intermediary variable for handling the recursive nesting.
// const SimpleModalWrapped = withStyles(styles)(SimpleModal);

export default connect(mapStateToProps)(withStyles(styles)(SimpleModal));
